export class ContainerOccupancyReport
{
    public deviceId?:string
    public beforeDate?:Date
    public afterDate?:Date
    public beforeOccupancy?:number
    public afterOccupancy?:number
    public containerName?:string
    public address?:string
}
export class StartEndDate{
    startTime?:Date;
    endTime?:Date;
}